import React, { useContext, useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import AppBreadCrumb from '../../common/AppBreadCrumb'

import { getPartygroups } from '../../../api/PartygroupsAPI ';
import { createPartygroup,updatePartygroup, fetchPartygroup} from '../../../api/PartygroupsAPI ';
import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter, replaceHyphenwithSpace } from '../../../commonfunctions';
import { getRoles } from '../../../api/milma_admin/RolesAPI';
import { AuthContext } from '../../AuthContext';

const PartygroupsForm = (props) => {

  const { formType, currentPartygroupId } = props;
  const navigate = useNavigate();
  const formRef = useRef(null);
 

  const [currentPartygroup, setCurrentPartygroup] = useState(null);
  const [currentPartygroupError, setCurrentPartygroupError] = useState(null);
  const [roles, setRoles] = useState([]);

  const [showToaster, setShowToaster] = useState(false);
  const [toaster, setToaster] = useState({});
  const [selectedRoles, setSelectedRoles] = useState(new Set());




  useEffect(() => {

    getRoles({ paginate: false }, function (response) {
      console.log("hello", response.roles);

      setRoles(response.roles);
      ;

    });



  }, []);




  const customStyles = {
    option: (provided, user) => ({
      ...provided,
      color: 'black', // Set label color to black
      backgroundColor: user.isFocused ? '#11a1fd' : 'white', // Blue on hover, white otherwise
      color: user.isFocused ? 'white' : 'black', //White text on blue, black otherwise
      padding: '15',
    }),
    control: (provided) => ({
      ...provided,
      borderColor: 'rgba(98,98,98, 0.4)', // Optional: customize the border
    }),
    singleValue: (provided, Partygroup) => ({
      ...provided,
      textAlign: 'left', // Align the selected value text to the left
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0.5rem 0.5rem',
    }),

  };


  const saveAddPartygroupForm = (exitForm) => {

    console.log("new Partygroup is", currentPartygroup);

    setCurrentPartygroupError({});
     const rolesArray = [...selectedRoles];
    const savePartygroup = { ...currentPartygroup };

    createPartygroup(savePartygroup, function (response) {
      console.log("in createPartygroup", response);

      if ("partygroup" in response) {


        // setSaveCompleted(prevPartygroup => !prevPartygroup); // Toggle the Partygroup
        if (exitForm) {

          navigate('/franchisee_user/masters/partygroups', {
            state: { message: 'Partygroup saved successfully!' }
          });
        }
        else {
          setShowToaster(true);
          setToaster({ type: 'success', heading: 'Success', message: 'Partygroup Added Successfully' });
          setCurrentPartygroup(null);
          setSelectedRoles(new Set());
        }
      }
      else {
        // Use the generic error handling function
        console.log("error Response", response);

        handleApiError(response, setCurrentPartygroupError);
      }


    });

  }

  const handleResetPartygroupForm = () => {

    setCurrentPartygroup(null);
    setCurrentPartygroupError(null);
  }

  const getTitle = () => {

    console.log("formType", formType);

    if (formType == 'create') {
      return 'Create New Partygroup Wizard'
    }
    else {
      return 'Edit Partygroup Wizard'
    }
  }

  useEffect(() => {
    setCurrentPartygroup(null);

    if (formType != null && formType != 'create' && currentPartygroupId) {

      fetchPartygroup(currentPartygroupId, function (response) {
        console.log("in fetchPartygroup", response);

        if ("partygroup" in response) {
         
          setCurrentPartygroup(response.partygroup);
          


        }



      });
    }

  }, [formType, currentPartygroupId]);


  const saveEditPartygroupForm = (exitForm) => {


    setCurrentPartygroupError(null);
    
    const savePartygroup = { ...currentPartygroup };
    updatePartygroup(currentPartygroup, function (response) {
      console.log("in updatePartygroup", response);

      if ("partygroup" in response) {

        // setToaster({ type: 'success', heading: 'Success', message: 'Partygroup Updated Successfully' });
        // setShowToaster(true);
        navigate('/franchisee_user/masters/partygroups', {
          state: { message: 'Partygroup Updated successfully!' }
        });

      }
      else {
        // Use the generic error handling function
        handleApiError(response, setCurrentPartygroupError);
      }


    });
  }

  // Function to handle individual permission checkbox changes
  const handleRoleChange = (roleId, isChecked) => {
    setSelectedRoles(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (isChecked) {
        newSelected.add(roleId);
      } else {
        newSelected.delete(roleId);
      }
      console.log("newselected",newSelected);
      return newSelected;
    });
    console.log("selectedRoles",selectedRoles);
    
   
  };




  // Helper function to check if a permission is selected
  const isRoleSelected = (roleId) => selectedRoles.has(roleId);



  return (
    <>
      <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster}></AppToaster>
      <main>
        <div className="container-fluid">
          {/* Breadcrumb start */}
          <AppBreadCrumb title={getTitle()}>
            <li>
              <a className="f-s-14 f-w-500" href="#">Masters</a>
            </li>
            <li>
              <a className="f-s-14 f-w-500" href="#">Partygroup Masters</a>
            </li>
            <li >
              <a className="f-s-14 f-w-500" href="#">Partygroups</a>
            </li>
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a>
            </li>
          </AppBreadCrumb>


          {/* Breadcrumb end */}
          {/* ready to use form start */}
          <div className="row">
            {/* Book Appointment Form start */}
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5>{formType == 'create' ? 'Add New' : 'Edit'} Partygroup  {formType == 'edit' ? (':' + currentPartygroup?.name) : ''}</h5>
                </div>
                <div className="card-body">
                  <form className="app-form" >
                    <div className="row">
                    
                      <div className="col-md-12">
                        <div >
                          <label className="form-label"> Name *</label>
                          <input className="form-control"  placeholder="Enter Name" value={currentPartygroup ? currentPartygroup.name : ''} onChange={(e) => setCurrentPartygroup({ ...currentPartygroup, name: e.target.value })} required type="text" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentPartygroupError?.name}</span>
                        </div>
                       
                        
                      </div>

                     
                      

                    

                    


                      <div className="col-12">
                        <div className="text-end">
                          {formType == 'create' ? (
                            <>
                              <button className="btn btn-outline-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveAddPartygroupForm(0)}>Save + Next
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="btn btn-primary me-2 btn-sm btn-md " type="button" onClick={() => saveAddPartygroupForm(1)}>Save + Exit
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M11 12H22M11 12L15 8M11 12L15 16" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="d-none d-md-inline-block btn btn-danger btn-sm btn-md btn-mobile-padding me-2" onClick={handleResetPartygroupForm} type="reset">Reset</button>
                            </>
                          ) : (
                            <>
                              <button className="btn btn-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveEditPartygroupForm(1)}> Update
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                             
                            </>
                          )}

                          <button className="d-none  d-md-inline-block btn btn-light-reddit b-r-22 d-inline-flex-center" type="button" onClick={() => navigate('/franchisee_user/masters/partygroups')} >
                          
                            Go Back</button>


                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Book Appointment Form end */}




          </div>
          {/* ready to use form and */}
        </div>
      </main>

    </>
  )
}

export default PartygroupsForm
